(function() {
    const contactMapEl = document.querySelector('.jsContactMap');
    const mapZoom = 15;

    if (contactMapEl) {
        if (googleMapsApiIsLoaded) initMap();
        else window.addEventListener('se-gm-api-loaded', _ => initMap());
    }

    function initMap() {
        // Init the map
        const map = new google.maps.Map(contactMapEl, {
            center: mapsLocation,
            zoom: mapZoom,
            disableDefaultUI: true,
            zoomControl: true,
            scrollwheel: false
        });

        // On resize, center the map
        window.addEventListener('resize', _ => {
            map.setCenter(mapsLocation);
            map.setZoom(mapZoom);
        });

        // Add the marker to the map
        new google.maps.Marker({
            position: mapsLocation,
            map: map,
            icon: { url: mapsIcon, scaledSize: new google.maps.Size(94, 94) }
        });
    }
})();
